export const sortBy = (array, iteratees) => {
  return array.slice().sort((a, b) => {
    for (let i = 0; i < iteratees.length; i++) {
      const iteratee = iteratees[i];
      const valueA = typeof iteratee === 'function' ? iteratee(a) : a[iteratee];
      const valueB = typeof iteratee === 'function' ? iteratee(b) : b[iteratee];

      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }
    }

    return 0;
  });
};
